module.exports = __webpack_public_path__ + "static/media/bell.0d6def5a.svg";